<div class="campaign-summary loader-wrapper">
  <form
    class="promo-ads-form"
    (keydown.enter)="$event.preventDefault()"
    *ngIf="campaign"
  >
    <section class="use-promo-ads">
      <h1>
        {{ "brand.campaign.promoAds.title" | translate }}
        <app-tooltip
          text="{{ 'brand.campaign.promoAds.titleTooltip' | translate }}"
        >
        </app-tooltip>
      </h1>
      <p class="question">
        {{ "brand.campaign.promoAds.usePromoAdsQuestion" | translate }}
      </p>
      <mat-radio-group
        name="promoAdsEnabled"
        [(ngModel)]="campaign.promoAdsEnabled"
        [disabled]="!isEditable"
        (change)="updateCampaign()"
      >
        <mat-radio-button data-test="use-ads" [value]="true">{{
          "brand.campaign.promoAds.usePromoAdsQuestionYes" | translate
        }}</mat-radio-button>
        <mat-radio-button data-test="without-ads" [value]="false">{{
          "brand.campaign.promoAds.usePromoAdsQuestionNo" | translate
        }}</mat-radio-button>
      </mat-radio-group>
    </section>
    <section *ngIf="campaign.promoAdsEnabled && page === PromoAdsPage.Settings">
      <div class="section-wrap">
        <div class="section-wrap--column section-wrap--column-left">
          <div class="section-wrap--column-title">
            <h2>{{ "brand.campaign.promoAds.generalSettings" | translate }}</h2>
          </div>
          <div
            class="section-wrap--column-content section-wrap--column-content-page-one"
          >
            <!-- TYPE OF FUNDING -->
            <div class="sub-section-title sub-section-title--first">
              {{ "brand.campaign.promoAds.typeOfFunding" | translate }}
              <app-tooltip
                class="sub-section-title--tooltip"
                text="{{
                  'brand.campaign.promoAds.typeOfFundingTooltip' | translate
                }}"
              >
              </app-tooltip>
            </div>
            <div class="payment-type">
              <div class="payment-type--column">
                <mat-form-field>
                  <mat-select
                    name="payment-type"
                    [(ngModel)]="campaign.paymentType"
                    [disabled]="!isEditable"
                    (ngModelChange)="updateCampaign()"
                  >
                    <mat-option [value]="PaymentType.Brand">{{
                      "shared.campaignPaymentType.brandFunded" | translate
                    }}</mat-option>
                    <mat-option [value]="PaymentType.CoFunded">{{
                      "shared.campaignPaymentType.coFunded" | translate
                    }}</mat-option>
                    <mat-option [value]="PaymentType.Self">{{
                      "shared.campaignPaymentType.selfFunded" | translate
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div
                *ngIf="campaign.paymentType === PaymentType.CoFunded"
                class="payment-type--column"
              >
                <div class="payment-type--indicator-left">
                  {{ campaign.paymentTypePercentage }} %
                  {{ "shared.brand" | translate }}
                </div>
                <div class="payment-type--indicator-right">
                  {{ 100 - campaign.paymentTypePercentage }} %
                  {{ "shared.partner" | translate }}
                </div>
                <mat-slider
                  step="5"
                  name="paymentTypePercentage"
                  [disabled]="!isEditable"
                  class="slider payment-type--slider"
                  [max]="100"
                  [min]="0"
                  #ngSlider
                  ><input
                    matSliderThumb
                    [(ngModel)]="campaign.paymentTypePercentage"
                    (input)="paymentTypePercentageChange(ngSliderThumb.value)"
                    [disabled]="!isEditable"
                    #ngSliderThumb="matSliderThumb"
                    (change)="updateCampaign()"
                  />
                </mat-slider>
              </div>
            </div>
            <div>
              <!-- CURRENCY -->
              <div class="sub-section-title sub-section-title--currency">
                {{ "brand.campaign.promoAds.currency" | translate }}
              </div>
              <mat-form-field>
                <mat-select
                  name="payment-currency"
                  [(ngModel)]="campaign.currency"
                  [disabled]="!isEditable"
                  (ngModelChange)="updateCampaignCurrency()"
                >
                  <mat-option [value]="CampaignCurrency.EUR">{{
                    CampaignCurrency.EUR
                  }}</mat-option>
                  <mat-option [value]="CampaignCurrency.USD">{{
                    CampaignCurrency.USD
                  }}</mat-option>
                  <mat-option [value]="CampaignCurrency.GBP">{{
                    CampaignCurrency.GBP
                  }}</mat-option>
                  <mat-option [value]="CampaignCurrency.CHF">{{
                    CampaignCurrency.CHF
                  }}</mat-option>
                  <mat-option [value]="CampaignCurrency.SEK">{{
                    CampaignCurrency.SEK
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <!-- START AND END -->
            <div class="sub-section-title sub-section-title--dates">
              {{ "brand.campaign.promoAds.startEndTimeTitle" | translate }}
              <app-tooltip
                class="sub-section-title--tooltip"
                text="{{
                  'brand.campaign.promoAds.startEndTooltip' | translate
                }}"
              >
              </app-tooltip>
            </div>
            <div class="ad-dates">
              <mat-checkbox
                [checked]="campaign.adDatesType === CAMPAIGN_SAME_DATES_TYPE"
                (change)="datesTypeChanged($event)"
                [value]="CAMPAIGN_SAME_DATES_TYPE"
                [disabled]="!isEditable"
              >
                {{ "brand.campaign.promoAds.startEndTimeSame" | translate }}
                ({{ campaign.startDate | date: dateFormat() }}
                {{ "brand.campaign.promoAds.startEndTimeSameTo" | translate }}
                {{ campaign.endDate | date: dateFormat() }})
              </mat-checkbox>
              <mat-checkbox
                [checked]="campaign.adDatesType === CAMPAIGN_CUSTOM_DATES_TYPE"
                (change)="datesTypeChanged($event)"
                [value]="CAMPAIGN_CUSTOM_DATES_TYPE"
                [disabled]="!isEditable"
                >{{
                  "brand.campaign.promoAds.startEndTimeSpecific" | translate
                }}
              </mat-checkbox>
              <div class="ad-dates--content">
                <mat-form-field>
                  <mat-label>{{ "shared.startDate" | translate }}</mat-label>
                  <input
                    matInput
                    [ngModel]="adsStartDate | dayjsTransform"
                    name="fb-start-date"
                    [matDatepicker]="fromDate"
                    (dateChange)="
                      validateAndUpdateCampaignStartDate($event.value)
                    "
                    [min]="minDate | dayjsTransform"
                    [max]="maxDate | dayjsTransform"
                    (focus)="fromDate.open()"
                    [disabled]="
                      !isEditable ||
                      campaign.adDatesType !== CAMPAIGN_CUSTOM_DATES_TYPE
                    "
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="fromDate"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #fromDate></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>{{ "shared.endDate" | translate }}</mat-label>
                  <input
                    matInput
                    [ngModel]="adsEndDate | dayjsTransform"
                    name="fb-end-date"
                    [matDatepicker]="toDate"
                    (dateChange)="
                      validateAndUpdateCampaignEndDate($event.value)
                    "
                    [min]="minDate | dayjsTransform"
                    [max]="maxDate | dayjsTransform"
                    (focus)="toDate.open()"
                    [disabled]="
                      !isEditable ||
                      campaign.adDatesType !== CAMPAIGN_CUSTOM_DATES_TYPE
                    "
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="toDate"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #toDate></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

            <!-- TARGET GENDER -->
            <div class="sub-section-title sub-section-title--gender">
              {{ "brand.campaign.promoAds.targetGender" | translate }}
              <app-tooltip
                class="sub-section-title--tooltip"
                text="{{
                  'brand.campaign.promoAds.targetGenderTooltip' | translate
                }}"
              >
              </app-tooltip>
            </div>
            <div class="gender-selection">
              <mat-checkbox
                [checked]="
                  campaign.gender === Gender.Male ||
                  campaign.gender === Gender.Both
                "
                (change)="genderChanged($event)"
                [value]="Gender.Male"
                [disabled]="!isEditable"
                >{{ "shared.male" | translate }}
              </mat-checkbox>
              <mat-checkbox
                [checked]="
                  campaign.gender === Gender.Female ||
                  campaign.gender === Gender.Both
                "
                (change)="genderChanged($event)"
                [value]="Gender.Female"
                [disabled]="!isEditable"
                >{{ "shared.female" | translate }}
              </mat-checkbox>
            </div>
            <!-- TARGET AGE -->
            <div class="sub-section-title sub-section-title--age">
              {{ "brand.campaign.promoAds.targetAge" | translate }}
              <app-tooltip
                class="sub-section-title--tooltip"
                text="{{
                  'brand.campaign.promoAds.targetAgeTooltip' | translate
                }}"
              >
              </app-tooltip>
            </div>
            <div class="sub-section-subtitle">
              {{ "brand.campaign.promoAds.targetAgeMinMax" | translate }}
            </div>
            <div class="age-selection">
              <ng-container *ngFor="let ageRange of ageRanges">
                <mat-checkbox
                  [checked]="hasAgeRange(ageRange.value)"
                  (change)="ageRangeChanged($event.source.value)"
                  [value]="ageRange.value"
                  [disabled]="!isEditable"
                  >{{ ageRange.name }}
                </mat-checkbox>
              </ng-container>
            </div>
            <!-- TARGET RADIUS -->
            <div class="sub-section-title sub-section-title--radius">
              {{ "brand.campaign.promoAds.targetRadius" | translate }}
              <app-tooltip
                class="sub-section-title--tooltip"
                text="{{
                  'brand.campaign.promoAds.targetRadiusTooltip' | translate
                }}"
              >
              </app-tooltip>
            </div>
            <div class="ad-radius-selection">
              <google-map
                *ngIf="mapCenter"
                height="148px"
                width="100%"
                [zoom]="7"
                [center]="mapCenter"
              >
                <map-marker
                  *ngFor="let markerAddress of markers"
                  [position]="markerAddress"
                  [options]="{
                    icon: '/assets/images/icons/ic_orange_marker.svg'
                  }"
                ></map-marker>
                <map-circle
                  [center]="mapCenter"
                  [radius]="campaign.adTargetRadius * 1000"
                  [options]="{ fillColor: 'blue', clickable: false }"
                ></map-circle>
              </google-map>
              <div class="ad-radius-selection--radius">
                <mat-slider
                  step="5"
                  [discrete]="true"
                  [disabled]="!isEditable"
                  class="slider slider-thumb radius--slider"
                  [max]="maxRadiusDistance"
                  [min]="minRadiusDistance"
                  #ngSlider
                  ><input
                    matSliderThumb
                    [disabled]="!isEditable"
                    (change)="updateCampaign()"
                    name="radiusSlider"
                    [(ngModel)]="campaign.adTargetRadius"
                    #ngSliderThumb="matSliderThumb"
                  />
                </mat-slider>
                <div class="slider-max-min">
                  <div>{{ minRadiusDistance }} km</div>
                  <div>{{ maxRadiusDistance }} km</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section-wrap--column section-wrap--column-right">
          <div class="section-wrap--column-title">
            <h2>{{ "brand.campaign.promoAds.budget" | translate }}</h2>
          </div>
          <div
            class="section-wrap--column-content section-wrap--column-content-page-one"
          >
            <!-- TOTAL BUDGET -->
            <div class="sub-section-title sub-section-title--first">
              {{ "brand.campaign.promoAds.totalLimitPerPartner" | translate }}
              <app-tooltip
                class="sub-section-title--tooltip"
                text="{{
                  'brand.campaign.promoAds.totalBudgetLimitTooltip' | translate
                }}"
              >
              </app-tooltip>
            </div>
            <div class="sub-section-subtitle sub-section-subtitle--ads">
              {{
                "brand.campaign.promoAds.totalLimitPerPartnerSubtitle"
                  | translate
              }}
            </div>
            <mat-slider
              step="10"
              [discrete]="true"
              [disabled]="!isEditable"
              class="slider slider-thumb"
              [max]="maxBudget"
              [min]="0"
              #ngSlider
              ><input
                matSliderThumb
                name="budget"
                [disabled]="!isEditable"
                [(ngModel)]="campaign.budget"
                (change)="updateCampaign()"
                #ngSliderThumb="matSliderThumb"
              />
            </mat-slider>
            <div class="slider-max-min">
              <div>0 {{ campaign.currencySymbol }}</div>
              <div>{{ maxBudget }} {{ campaign.currencySymbol }}</div>
            </div>

            <!-- ADS PER PARTNER -->
            <div class="sub-section-title sub-section-title--ads">
              {{ "brand.campaign.promoAds.maxAdsPerPartner" | translate }}
              <app-tooltip
                class="sub-section-title--tooltip"
                text="{{
                  'brand.campaign.promoAds.maxAdsPerPartnerTooltip'
                    | translate: { currency: campaign.currencySymbol }
                }}"
              >
              </app-tooltip>
            </div>
            <div class="sub-section-subtitle sub-section-subtitle--ads">
              {{ "brand.campaign.promoAds.maxAdsPerPartnerSubtitle" | translate
              }}<br />
              {{
                "brand.campaign.promoAds.maxAdsPerPartnerDetails"
                  | translate: { adsInCalendar: campaign.totalAdsInCalendar }
              }}
            </div>
            <mat-slider
              [discrete]="true"
              [disabled]="!isEditable"
              class="slider slider-thumb"
              [max]="maxAmountOfAds"
              [min]="getMinAmountOfAds"
              #ngSlider
              ><input
                matSliderThumb
                name="maxAds"
                [disabled]="!isEditable"
                [(ngModel)]="campaign.maxAdsCampaignPartner"
                (change)="updateCampaign()"
                #ngSliderThumb="matSliderThumb"
              />
            </mat-slider>
            <div class="slider-max-min">
              <div>{{ getMinAmountOfAds }}</div>
              <div>{{ maxAmountOfAds }}</div>
            </div>

            <!-- MAX DURATION -->
            <div class="sub-section-title sub-section-title--ads">
              {{ "brand.campaign.promoAds.maxDurationPerAd" | translate }}
              <app-tooltip
                class="sub-section-title--tooltip"
                text="{{
                  'brand.campaign.promoAds.maxDurationTooltip'
                    | translate: { currency: campaign.currencySymbol }
                }}"
              >
              </app-tooltip>
            </div>
            <div class="sub-section-subtitle">
              {{ "brand.campaign.promoAds.maxDurationSubtitle" | translate }}
            </div>
            <mat-slider
              [discrete]="true"
              [disabled]="!isEditable"
              class="slider slider-thumb"
              [max]="maxAdDuration"
              [min]="0"
              #ngSlider
              ><input
                matSliderThumb
                name="maxDays"
                [disabled]="!isEditable"
                [(ngModel)]="campaign.adDuration"
                (change)="updateCampaign()"
                #ngSliderThumb="matSliderThumb"
              />
            </mat-slider>
            <div class="slider-max-min">
              <div>0</div>
              <div>{{ maxAdDuration }}</div>
            </div>

            <app-budget-plan
              class="budget-plan"
              [currencySymbol]="campaign.currencySymbol"
              [budget]="campaign.budget"
              [maxAdsPerPartner]="campaign.maxAdsCampaignPartner"
              [maxAdDurationDays]="campaign.adDuration"
            />
          </div>
        </div>
      </div>
      <div class="next-button-wrap">
        <button
          (click)="nextPage()"
          [disabled]="loadingPage"
          class="button button-orange"
        >
          <strong>{{
            "brand.campaign.promoAds.stepOneOfTwo" | translate
          }}</strong>
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </section>
    <section
      *ngIf="
        campaign.promoAdsEnabled && page === PromoAdsPage.MarketingChannels
      "
    >
      <div class="section-wrap">
        <div class="section-wrap--column section-wrap--column-left">
          <div class="section-wrap--column-title">
            <img
              class="ads-logo"
              src="/assets/images/facebook-post-logo.svg"
              width="18"
            />
            <img
              class="ads-logo"
              src="/assets/images/instagram-post-logo.svg"
              width="18"
            />
            <h2>
              {{ "brand.campaign.promoAds.facebookInstagramAds" | translate }}
            </h2>
          </div>
          <div
            class="section-wrap--column-content section-wrap--column-content-page-two"
          >
            <!-- USE FACEBOOK ADS -->
            <div class="use-facebook-ads">
              <mat-radio-group
                name="useFacebookAds"
                [(ngModel)]="campaign.useFacebookAds"
                [disabled]="!isEditable"
                (ngModelChange)="updateCampaign()"
              >
                <mat-radio-button [value]="true">{{
                  "brand.campaign.promoAds.useFacebookAds" | translate
                }}</mat-radio-button>
                <mat-radio-button [value]="false">{{
                  "brand.campaign.promoAds.doNotUseFacebookAds" | translate
                }}</mat-radio-button>
              </mat-radio-group>
            </div>

            <div *ngIf="campaign.useFacebookAds">
              <!-- PUBLISHER PLATFORMS -->
              <div class="sub-section-title">
                {{ "brand.campaign.promoAds.publisherPlatforms" | translate }}
                <app-tooltip
                  class="sub-section-title--tooltip"
                  text="{{
                    'brand.campaign.promoAds.publisherPlatformsTooltip'
                      | translate
                  }}"
                >
                </app-tooltip>
              </div>
              <div class="platform-selection">
                <mat-checkbox
                  name="publisher-platform-facebook"
                  [(ngModel)]="campaign.publisherPlatformFacebook"
                  [value]="1"
                  [disabled]="!isEditable"
                  (ngModelChange)="updateCampaign()"
                  >{{ "shared.facebook" | translate }}
                </mat-checkbox>
                <mat-checkbox
                  name="publisher-platform-instagram"
                  [(ngModel)]="campaign.publisherPlatformInstagram"
                  [value]="1"
                  [disabled]="!isEditable"
                  (ngModelChange)="updateCampaign()"
                  >{{ "shared.instagram" | translate }}
                </mat-checkbox>
                <mat-checkbox
                  name="publisher-platform-audience-network"
                  [(ngModel)]="campaign.publisherPlatformAudienceNetwork"
                  [value]="1"
                  [disabled]="
                    !isEditable || campaign.type === CAMPAIGN_TYPE_DOWNLOAD_ONLY
                  "
                  (ngModelChange)="updateCampaign()"
                  >{{ "shared.audienceNetwork" | translate }}
                </mat-checkbox>
              </div>

              <!-- AD TYPE -->
              <div class="sub-section-title">
                {{ "brand.campaign.promoAds.facebookAdType" | translate }}
                <app-tooltip
                  class="sub-section-title--tooltip"
                  text="{{
                    'brand.campaign.promoAds.facebookAdTypeTooltip' | translate
                  }}"
                >
                </app-tooltip>
              </div>
              <div class="ad-type-selection">
                <mat-form-field>
                  <mat-label>{{
                    "brand.campaign.promoAds.selectActionType" | translate
                  }}</mat-label>
                  <mat-select
                    name="adActionType"
                    [(ngModel)]="campaign.adActionType"
                    [disabled]="!isEditable"
                    (ngModelChange)="updateCampaign()"
                  >
                    <mat-option
                      [disabled]="isBoostPostAdTypeDisabled"
                      value="boost"
                      >{{
                        "brand.campaign.promoAds.actionTypeBoosted" | translate
                      }}</mat-option
                    >
                    <mat-option
                      *ngIf="!isAdTypeAdWithLinkDisabled()"
                      value="link"
                      >{{
                        "brand.campaign.promoAds.actionTypeAdWithLink"
                          | translate
                      }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- OBJECTIVE -->
              <div class="sub-section-title">
                {{ "brand.campaign.promoAds.objective" | translate }}
                <app-tooltip
                  class="sub-section-title--tooltip"
                  text="{{
                    'brand.campaign.promoAds.optimizationTooltip' | translate
                  }}"
                >
                </app-tooltip>
              </div>
              <div class="objective-selection">
                <mat-form-field>
                  <mat-label>{{
                    "brand.campaign.promoAds.optimizationTarget" | translate
                  }}</mat-label>
                  <mat-select
                    name="objective"
                    [(ngModel)]="campaign.objective"
                    [disabled]="!isEditable"
                    (ngModelChange)="updateCampaign()"
                  >
                    <mat-option value="REACH">{{
                      "brand.campaign.promoAds.optimizationTargetReach"
                        | translate
                    }}</mat-option>
                    <mat-option
                      *ngIf="campaign.type !== CAMPAIGN_TYPE_DOWNLOAD_ONLY"
                      value="LINK_CLICKS"
                      >{{
                        "brand.campaign.promoAds.optimizationTargetLinkClicks"
                          | translate
                      }}</mat-option
                    >
                    <mat-option
                      *ngIf="campaign.type !== CAMPAIGN_TYPE_DOWNLOAD_ONLY"
                      value="CONVERSIONS"
                      >{{
                        "brand.campaign.promoAds.optimizationTargetConversions"
                          | translate
                      }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- HEADING -->
              <div class="sub-section-title">
                {{ "brand.campaign.promoAds.heading" | translate }}
                <app-tooltip
                  class="sub-section-title--tooltip"
                  text="{{
                    'brand.campaign.promoAds.headingTooltip' | translate
                  }}"
                >
                </app-tooltip>
              </div>
              <div class="heading-selection">
                <mat-form-field>
                  <mat-label>{{
                    "brand.campaign.promoAds.headingPlaceholder" | translate
                  }}</mat-label>
                  <input
                    matInput
                    maxlength="255"
                    name="heading"
                    [(ngModel)]="campaign.facebookAdsDefaultHeading"
                    [disabled]="!isEditable"
                    (blur)="updateCampaign()"
                  />
                </mat-form-field>
              </div>

              <!-- DESCRIPTION -->
              <div class="sub-section-title">
                {{ "brand.campaign.promoAds.description" | translate }}
                <app-tooltip
                  class="sub-section-title--tooltip"
                  text="{{
                    'brand.campaign.promoAds.descriptionTooltip' | translate
                  }}"
                >
                </app-tooltip>
              </div>
              <div class="description-selection">
                <mat-form-field>
                  <mat-label>{{
                    "brand.campaign.promoAds.descriptionPlaceholder" | translate
                  }}</mat-label>
                  <input
                    matInput
                    maxlength="255"
                    name="description"
                    [(ngModel)]="campaign.facebookAdsDefaultDescription"
                    [disabled]="!isEditable"
                    (blur)="updateCampaign()"
                  />
                </mat-form-field>
              </div>

              <!-- CTA -->
              <div class="sub-section-title">
                {{ "brand.campaign.promoAds.cta" | translate }}
                <app-tooltip
                  class="sub-section-title--tooltip"
                  text="{{
                    'brand.campaign.promoAds.callToActionTooltip' | translate
                  }}"
                >
                </app-tooltip>
              </div>
              <div class="cta-selection">
                <mat-form-field class="full-width">
                  <mat-label>{{
                    "brand.campaign.promoAds.ctaSelectText" | translate
                  }}</mat-label>
                  <mat-select
                    name="adText"
                    [(ngModel)]="campaign.postsCtaText"
                    [disabled]="!isEditable"
                    (ngModelChange)="updateCampaign()"
                  >
                    <mat-option
                      *ngFor="let type of CtaText | keys"
                      value="{{ type }}"
                      >{{ CtaText[type] }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- BRANDED CONTENT ID -->
              <div class="sub-section-title">
                {{ "brand.campaign.promoAds.brandedContentPageId" | translate }}
                <app-tooltip
                  class="sub-section-title--tooltip"
                  text="{{
                    'brand.campaign.promoAds.brandedContentPageIdTooltip'
                      | translate
                  }}"
                >
                </app-tooltip>
              </div>
              <div class="branded-content-selection">
                <mat-form-field>
                  <mat-label>{{
                    "brand.campaign.promoAds.brandedContentPageIdPlaceholder"
                      | translate
                  }}</mat-label>
                  <input
                    matInput
                    name="fbId"
                    [(ngModel)]="campaign.brandedContentPageId"
                    [disabled]="!isEditable"
                    (blur)="updateCampaign()"
                  />
                </mat-form-field>
              </div>

              <!--FACEBOOK TARGETING -->
              <div class="sub-section-title">
                {{
                  "brand.campaign.promoAds.facebookAudienceTargeting"
                    | translate
                }}
                <app-tooltip
                  class="sub-section-title--tooltip"
                  text="{{
                    'brand.campaign.promoAds.facebookAdsAudienceTooltip'
                      | translate
                  }}"
                >
                </app-tooltip>
              </div>
              <div
                class="facebook-targeting"
                *ngIf="
                  facebookTargetingCategories &&
                  facebookTargetingCategories.length > 0
                "
              >
                <mat-expansion-panel
                  (opened)="panelOpenState = true"
                  (closed)="panelOpenState = false"
                >
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{
                        "brand.campaign.promoAds.facebookTargetingTitle"
                          | translate
                      }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <app-brand-campaign-facebook-targeting-picker
                    (facebookTargetingUpdated)="updateCampaign()"
                    [facebookTargetingCategories]="facebookTargetingCategories"
                    [campaign]="campaign"
                  />
                </mat-expansion-panel>
              </div>
            </div>
          </div>
        </div>
        <div class="section-wrap--column section-wrap--column-right">
          <div class="section-wrap--column-title">
            <img
              class="ads-logo"
              src="/assets/images/google-ad-logo.svg"
              width="18"
            />
            <h2>{{ "brand.campaign.promoAds.googleAds" | translate }}</h2>
          </div>
          <div
            class="section-wrap--column-content section-wrap--column-content-page-two"
          >
            <!-- USE GOOGLE ADS-->
            <div class="use-google-ads">
              <mat-radio-group
                name="useGoogleAds"
                [(ngModel)]="campaign.useGoogleAds"
                [disabled]="!isGoogleConfigEnabled()"
                (ngModelChange)="updateCampaign()"
              >
                <mat-radio-button [value]="true">{{
                  "brand.campaign.promoAds.useGoogleAds" | translate
                }}</mat-radio-button>
                <mat-radio-button [value]="false">{{
                  "brand.campaign.promoAds.doNotUseGoogleAds" | translate
                }}</mat-radio-button>
              </mat-radio-group>
            </div>
            <div *ngIf="campaign.useGoogleAds">
              <!-- AUTO START GOOGLE ADS -->
              <div class="sub-section-title">
                {{
                  "brand.campaign.promoAds.noAutoStartGoogleAdsTitle"
                    | translate
                }}
                <app-tooltip
                  class="sub-section-title--tooltip"
                  text="{{
                    'brand.campaign.promoAds.noAutoStartGoogleAdsTooltip'
                      | translate
                  }}"
                >
                </app-tooltip>
              </div>
              <div class="no-auto-start-google-ads-selection">
                <mat-checkbox
                  name="no-auto-start-google-ads"
                  [(ngModel)]="campaign.noAutoStartGoogleAds"
                  [value]="1"
                  [disabled]="
                    !isEditable ||
                    campaign.campaignBudgetType ===
                      CampaignBudgetTypes.TimeFrame
                  "
                  (ngModelChange)="updateCampaign()"
                  >{{
                    "brand.campaign.promoAds.noAutoStartGoogleAdsCheckbox"
                      | translate
                  }}
                </mat-checkbox>
              </div>

              <!-- BRANDED CONTENT ID -->
              <div class="sub-section-title">
                {{
                  "brand.campaign.promoAds.googleAdsCampaignObjective"
                    | translate
                }}
                <app-tooltip
                  class="sub-section-title--tooltip"
                  text="{{
                    'brand.campaign.promoAds.googleAdsCampaignObjectiveTooltip'
                      | translate
                  }}"
                >
                </app-tooltip>
              </div>
              <div class="objective-selection">
                <mat-form-field>
                  <mat-label>{{
                    "brand.campaign.promoAds.googleAdsCampaignObjectiveLabel"
                      | translate
                  }}</mat-label>
                  <mat-select
                    name="googleAdsBiddingStrategyType"
                    [(ngModel)]="campaign.googleAdsBiddingStrategyType"
                    [disabled]="!isEditable"
                    (ngModelChange)="updateCampaign()"
                  >
                    <mat-option
                      *ngFor="let strategy of googleAdsBiddingStrategyOptions"
                      [value]="strategy"
                    >
                      {{ "brand.campaign.promoAds." + strategy | translate }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- BRANDED CONTENT ID -->
              <div class="sub-section-title">
                {{ "brand.campaign.promoAds.googleAdsBidAmount" | translate }}
                <app-tooltip
                  class="sub-section-title--tooltip"
                  text="{{
                    'brand.campaign.promoAds.googleAdsBidAmountTooltip'
                      | translate
                  }}"
                >
                </app-tooltip>
              </div>
              <div class="sub-section-subtitle">
                {{
                  "brand.campaign.promoAds.googleAdsBidAmountSubtitle"
                    | translate
                }}
              </div>
              <mat-slider
                [discrete]="true"
                step="0.1"
                [disabled]="!isEditable"
                class="slider slider-thumb"
                [max]="maxGoogleAdGroupBid"
                [min]="minGoogleAdGroupBid"
                #ngSlider
                ><input
                  matSliderThumb
                  name="googleAdsBidAmount"
                  [disabled]="!isEditable"
                  (change)="updateCampaign()"
                  [(ngModel)]="campaign.googleAdGroupBid"
                  #ngSliderThumb="matSliderThumb"
                />
              </mat-slider>
              <div class="slider-max-min">
                <div>{{ minGoogleAdGroupBid }}</div>
                <div>{{ maxGoogleAdGroupBid }}</div>
              </div>
              <!-- GOOGLE ADS AUDIENCE -->
              <div class="sub-section-title">
                {{ "brand.campaign.promoAds.googleAdsAudiences" | translate }}
                <app-tooltip
                  class="sub-section-title--tooltip"
                  text="{{
                    'brand.campaign.promoAds.googleAdsAudienceTooltip'
                      | translate
                  }}"
                >
                </app-tooltip>
              </div>
              <div class="google-targeting" *ngIf="googleTargetingOptions">
                <mat-expansion-panel [expanded]="googleAdsPanelOpenState">
                  <mat-expansion-panel-header (click)="toggleGoogleAdsPanel()">
                    <mat-panel-title>
                      {{
                        "brand.campaign.promoAds.googleTargetingTitle"
                          | translate
                      }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <app-brand-campaign-google-targeting-picker
                    *ngIf="
                      googleAdsPanelOpenState && !loadingGoogleAdsTargeting
                    "
                    (googleTargetingUpdated)="updateCampaign()"
                    [googleTargetingOptions]="googleTargetingOptions"
                    [campaign]="campaign"
                  />
                </mat-expansion-panel>
              </div>
              <mat-progress-bar
                *ngIf="loadingGoogleAdsTargeting"
                [color]="'accent'"
                style="padding-top: 20px; height: 30px"
                mode="indeterminate"
              >
              </mat-progress-bar>

              <!--WHITELIST -->
              <div class="sub-section-title">
                {{
                  "brand.campaign.promoAds.placements.addPlacements" | translate
                }}
                <app-tooltip
                  text="{{
                    'brand.campaign.promoAds.placements.placementsTooltip'
                      | translate
                  }}"
                >
                </app-tooltip>
              </div>
              <mat-radio-group
                class="whitelist-radio-group"
                name="placements"
                [formControl]="placement"
              >
                <mat-radio-button value="Blacklist">{{
                  "brand.campaign.promoAds.placements.blacklistPlacements"
                    | translate
                }}</mat-radio-button>
                <mat-radio-button value="Whitelist">{{
                  "brand.campaign.promoAds.placements.whitelistPlacements"
                    | translate
                }}</mat-radio-button>
              </mat-radio-group>
              <div
                *ngIf="placement.value === PlacementType.Blacklist"
                class="whitelist-container"
              >
                <p
                  class="whitelist-element"
                  *ngFor="let element of campaign.googleAdsBlackListPlacements"
                >
                  {{ element }}
                </p>
                <p
                  class="whitelist-element no-placements"
                  *ngIf="!campaign.googleAdsBlackListPlacements.length"
                >
                  {{
                    "brand.campaign.promoAds.placements.noPlacementsBlacklist"
                      | translate
                  }}
                </p>
              </div>
              <div
                *ngIf="placement.value === PlacementType.Whitelist"
                class="whitelist-container"
              >
                <p
                  class="whitelist-element"
                  *ngFor="let element of campaign.googleAdsWhiteListPlacements"
                >
                  {{ element }}
                </p>
                <p
                  class="whitelist-element no-placements"
                  *ngIf="!campaign.googleAdsWhiteListPlacements.length"
                >
                  {{
                    "brand.campaign.promoAds.placements.noPlacementsWhitelist"
                      | translate
                  }}
                </p>
              </div>
              <div
                *ngIf="
                  campaign.campaignBrandStatus === BrandCampaignStatus.Draft
                "
                class="sub-section-title add-placement"
                (click)="addPlacement(placement.value)"
              >
                {{
                  placement.value === PlacementType.Blacklist
                    ? campaign.googleAdsBlackListPlacements.length
                      ? ("brand.campaign.promoAds.placements.editList"
                        | translate)
                      : ("brand.campaign.promoAds.placements.addList"
                        | translate)
                    : campaign.googleAdsWhiteListPlacements.length
                      ? ("brand.campaign.promoAds.placements.editList"
                        | translate)
                      : ("brand.campaign.promoAds.placements.addList"
                        | translate)
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="next-button-wrap">
        <button
          (click)="previousPage()"
          [disabled]="loadingPage"
          class="button button-orange"
        >
          <mat-icon>arrow_back</mat-icon>
          <strong>{{
            "brand.campaign.promoAds.stepTwoOfOne" | translate
          }}</strong>
        </button>
      </div>
    </section>
  </form>
  <app-autosave-tooltip [running]="saving" [error]="savingError" />
  <app-loader
    [text]="'shared.loadingCampaign' | translate"
    [ngClass]="{ visible: (brandCampaignService.isLoadingCampaign$ | async) }"
  />
</div>
